import React, { PropsWithChildren } from 'react';
import { Box, Flex } from '@fullstory/components';
import css from './noResultsContainer.module.scss';

interface NoResultsContainerProps {
  height?: number;
}

/** A wrapper for empty states, error states, etc within the ResourceList */
export const NoResultsContainer: React.FC<PropsWithChildren<NoResultsContainerProps>> = ({
  height = 625,
  children,
}) => (
  <Box data-component="NoResultsContainer" height={height}>
    <Flex column className={css.fillParent}>
      {children}
    </Flex>
  </Box>
);
